import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { NotificationsV1Service } from '../../api/services/notifications-v-1.service';
import { SystemAnnouncementsV1Service } from '../../api/services/system-announcements-v-1.service';
import { SystemAnnouncementV1, UserNotificationV1 } from '../../api/models';

/**
 * Thin facade over the generated notification clients (#48894).
 *
 * The list endpoints' OpenAPI annotations declare a single object instead of an array,
 * so the generated return types are `Observable<T>` while the API actually returns `T[]`.
 * The casts below correct that in one place; remove them once the backend @ApiResponse
 * schemas are fixed to ArraySchema and the client is regenerated.
 */
@Injectable({ providedIn: 'root' })
export class NotificationApiService {
  private readonly notifications = inject(NotificationsV1Service);
  private readonly announcements = inject(SystemAnnouncementsV1Service);

  listNotifications(archived = false): Observable<UserNotificationV1[]> {
    return this.notifications.listUserNotificationsV1({ archived }) as unknown as Observable<UserNotificationV1[]>;
  }

  markAsRead(notificationId: string): Observable<UserNotificationV1> {
    return this.notifications.markUserNotificationReadV1({ notificationId });
  }

  markAllAsRead(): Observable<void> {
    return this.notifications.markAllUserNotificationsReadV1();
  }

  archive(notificationId: string): Observable<UserNotificationV1> {
    return this.notifications.archiveUserNotificationV1({ notificationId });
  }

  unarchive(notificationId: string): Observable<UserNotificationV1> {
    return this.notifications.unarchiveUserNotificationV1({ notificationId });
  }

  getActiveMaintenance(): Observable<SystemAnnouncementV1[]> {
    return this.announcements.getActiveMaintenanceV1() as unknown as Observable<SystemAnnouncementV1[]>;
  }
}
